import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import moment from "moment";
import { getEventById, getAllOrganizer } from "api";

const EventDetails = () => {
  const { id } = useParams();

  const [originalData, setOriginalData] = useState(null);
  const [selectedThumbImg, setSelectedThumbImg] = useState(null);
  const [selectedOrganizer, setSelectedOrganizer] = useState(null);
  const [selectedEventTime, setSelectedEventTime] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [ticketStatus, setTicketStatus] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [otherFeesSelected, setOtherFeesSelected] = useState(null);
  const [ticketGrouping, setTicketGrouping] = useState(null);
  const [requireOtherAttendees, setRequireOtherAttendees] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [event, organizers] = await Promise.all([
          getEventById(id),
          getAllOrganizer(),
        ]);

        setOriginalData(event);
        setSelectedThumbImg(event.thumbImg);
        const organizer = organizers.find(
          org => String(org.organizerId) === String(event.organizerId));
        setSelectedOrganizer({value: event.organizerId,label: organizer?.name || "Unknown",});        
        setSelectedEventTime({ value: event.eventTime, label: event.eventTime });
        setSelectedStatus({ value: event.eventStatus, label: event.eventStatus });
        setTicketStatus({ value: event.ticketStatus, label: event.ticketStatus });
        setSelectedTemplate({ value: event.templateName, label: event.templateName });
        setOtherFeesSelected({ value: event.showOtherFees ? "yes" : "no", label: event.showOtherFees ? "Yes" : "No" });
        setTicketGrouping({ value: event.ticketGrouping, label: event.ticketGrouping });
        setRequireOtherAttendees(event.isOtherAttendeeRequired);
      } catch (error) {
        console.error("Error fetching event data:", error);
      }
    };

    fetchData();
  }, [id]);

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Events" breadcrumbItem="View Event" />

        {/* Event Information */}
        <Card className="mb-4">
          <CardBody>
            <h5 className="card-title mb-4">
              <i className="bx bx-info-circle me-2 text-primary"></i>
              Event Information
            </h5>
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label fw-semibold text-muted">Event Name</label>
                  <p className="mb-0 fs-5 fw-bold">{originalData?.eventName || "-"}</p>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label fw-semibold text-muted">Short Description</label>
                  <p className="mb-0 fs-5 fw-bold">{originalData?.shortDescription || "-"}</p>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <div className="mb-3">
                  <label className="form-label fw-semibold text-muted">Event Description</label>
                  <p className="mb-0 fs-5 fw-bold" dangerouslySetInnerHTML={{ __html: originalData?.eventDescription || "-" }} />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label fw-semibold text-muted">Thumbnail</label>
                  <div>
                    <img src={selectedThumbImg || ""} alt="thumbnail" style={{ maxWidth: "100px", height: "auto" }} />
                  </div>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label fw-semibold text-muted">Organizer</label>
                  <p className="mb-0 fs-5 fw-bold">{selectedOrganizer?.label || "-"}</p>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label fw-semibold text-muted">Event Status</label>
                  <p className="mb-0 fs-5 fw-bold">{selectedStatus?.label || "-"}</p>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label fw-semibold text-muted">Ticket Status</label>
                  <p className="mb-0 fs-5 fw-bold">{ticketStatus?.label || "-"}</p>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label fw-semibold text-muted">Template</label>
                  <p className="mb-0 fs-5 fw-bold">{selectedTemplate?.label || "-"}</p>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label fw-semibold text-muted">Location</label>
                  <p className="mb-0 fs-5 fw-bold">{originalData?.eventLocation || "-"}</p>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label fw-semibold text-muted">Date</label>
                  <p className="mb-0 fs-5 fw-bold">{originalData?.eventDate || "-"}</p>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label fw-semibold text-muted">Time</label>
                  <p className="mb-0 fs-5 fw-bold">{selectedEventTime?.label || "-"}</p>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* Pricing Details */}
        <Card className="mb-4">
          <CardBody>
            <h5 className="card-title mb-4">
              <i className="bx bx-dollar-circle me-2 text-primary"></i>
              Pricing Details
            </h5>
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label fw-semibold text-muted">Processing Fee</label>
                  <p className="mb-0 fs-5 fw-bold">{originalData?.processingFee || "-"}</p>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label fw-semibold text-muted">Ticket Fee</label>
                  <p className="mb-0 fs-5 fw-bold">{originalData?.ticketFee || "-"}</p>
                </div>
                <Row>
                  <Col md={6}>
                    <div className="mb-3">
                      <label className="form-label fw-semibold text-muted">
                        Platform Fee
                      </label>
                      <p className="mb-0 fs-5 fw-bold">
                        {originalData?.platformFee ?? "-"}
                      </p>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="mb-3">
                      <label className="form-label fw-semibold text-muted">
                        Platform Fee Type
                      </label>
                      <p className="mb-0 fs-5 fw-bold">
                        {originalData?.platformFeeType === "per_ticket"
                          ? "Per Ticket"
                          : originalData?.platformFeeType === "per_booking"
                          ? "Per Booking"
                          : "-"}
                      </p>
                    </div>
                  </Col>
                </Row>

              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label fw-semibold text-muted">Show Fees in Checkout</label>
                  <p className="mb-0 fs-5 fw-bold">{otherFeesSelected?.label || "-"}</p>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label fw-semibold text-muted">Ticket Grouping</label>
                  <p className="mb-0 fs-5 fw-bold">{ticketGrouping?.label || "-"}</p>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label fw-semibold text-muted">Require Other Attendees</label>
                  <p className="mb-0 fs-5 fw-bold">{requireOtherAttendees ? "Yes" : "No"}</p>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default EventDetails;
